import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-tabpanels'
};
var TabPanelsStyle = BaseStyle.extend({
  name: 'tabpanels',
  classes: classes
});

export { TabPanelsStyle as default };
//# sourceMappingURL=index.mjs.map
